import React, {useEffect, useRef, useState} from 'react';
import { VscClose } from 'react-icons/vsc';
import SignatureCanvas from 'react-signature-canvas';

export default function SignatureCard({ setSignature, setSignatureCard, signature }: any) {
  const [exampleHide, setExampleHide] = useState(false);
  const signCanvas = useRef(null) as React.MutableRefObject<any>;
  const clear = () => {
    signCanvas.current.clear();
    setExampleHide(false);
  }
  const save = () => {
    setSignature(signCanvas.current.toDataURL("image/webp"));
    setSignatureCard(false);
  };
  const mouseDown = () => {
    setExampleHide(true);
  }
  return (
    <div className='w-full h-[calc(100dvh)] absolute flex justify-center items-center bg-black bg-opacity-[70%] z-40'>
      <div className='w-[265px] sm:w-[308px] md:w-[750px] h-[301px] md:h-[752px] bg-white rounded-[5px] md:rounded-[12px] flex flex-col items-center'>
        <div className='w-full h-44 md:h-[110px] bg-[#F5F5F5] text-txtBlack flex justify-between items-center rounded-t-[5px] md:rounded-t-[12px]'>
          <p className='ml-20 text-20 md:ml-[50px] md:text-37 font-preBold'>전자서명</p>
          <VscClose onClick={() => setSignatureCard(false)} className='hover:cursor-pointer mr-15 text-22 md:mr-[37px] md:text-55' />
        </div>
        <p className='mt-17 mb-10 md:mt-[42px] md:mb-[25px] font-preLight w-[240px] sm:w-[274px] md:w-[685px] text-19 md:text-45 text-txtBlack'>사각형에 이름을 <span className='text-point'>정자</span>로 쓰세요.</p>
        <div className='relative'>
        <SignatureCanvas
          ref={signCanvas}
          canvasProps={{ className: 'w-[250px] sm:w-[274px] md:w-[685px] h-141 md:h-[352px] border border-[#E4E4E4] rounded-[5px] md:rounded-[12px] z-[999]' }}
          backgroundColor="transparent"
          onBegin={mouseDown}
        />
        {!exampleHide && <div onMouseDown={mouseDown} className='absolute text-[#CDCDCD] top-[15%] left-[10%] text-70 z-10'>홍 길 동</div> }
        </div>
        <div className='flex mt-13 md:mt-[32px]'>
          <div onClick={clear} className='hover:cursor-pointer w-72 sm:w-92 md:w-[230px] h-40 md:h-[100px] bg-[#E4E4E4] flex items-center justify-center rounded-[5px] md:rounded-[12px] text-18 md:text-37 text-[#9C9C9B] font-preLight mr-8 md:mr-[20px]'>다시 쓰기</div>
          <button onClick={save} className='text-white text-18 md:text-37 font-preLight w-153 sm:w-173 md:w-[432px] h-40 md:h-[100px] outline-none bg-gradient-to-r from-gdFrom to-gdTo rounded-[5px] md:rounded-[12px]'>전자서명 저장</button>
        </div>
      </div>
    </div>
  );
}
